<template>
	<div>
		<SettingsUniverse v-if="typeSystem === 1">
		</SettingsUniverse>
		<SettingsMobicar v-else>
		</SettingsMobicar>
	</div>
</template>

<script>
	import SettingsUniverse from '../Settings/SettingsUni'
	import SettingsMobicar from '../Settings/SettingsMobicar'

  export default {
    data : function () {
      return{
      }
    },
    mounted : function () {
    },
    computed : {
      typeSystem : function() {
        return this.$store.state.cars.list[this.$store.state.cars.current.index].device.type
      }
    },
    methods : {
    },
    components : {
      SettingsUniverse,
      SettingsMobicar
    }
  }
</script>